import styled, { css } from 'styled-components';
import { COLUMN_AUTO_SIZE } from './Table.constants.js';

const Td = styled.td.withConfig({
  componentId: "sc-1at9h9g-0"
})(["", " box-sizing:border-box;padding:", ";max-width:540px;overflow:hidden;", ";", ";"], ({
  colSize
}) => colSize && colSize !== COLUMN_AUTO_SIZE && css(["width:", "px;"], colSize), ({
  theme,
  isCheckboxColumn
}) => isCheckboxColumn ? theme.components.table.checkboxColumnPadding : theme.components.table.tdPadding, ({
  hasRowSpan
}) => hasRowSpan && css(["border-top:1px solid transparent;"]), ({
  groupLevel,
  theme
}) => groupLevel && css(["padding-left:calc(", " * ", ");"], groupLevel, theme.components.table.groupByIdentSpace));

export { Td };
//# sourceMappingURL=Td.js.map
